import { connect } from 'react-redux';
import Application from './';
import { toggleMobileMenu } from '../../actions/viewActions';

const mapStateToProps = state => ({
  mobileMenuOpened: state.view.mobileMenuOpened,
  router: state.router
});

const mapDispatchToProps = dispatch => ({
  toggleMobileMenu: visibility => dispatch(toggleMobileMenu(visibility)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Application);
